<template>
	<div id="previewImage">
		<img :src="imgUrl" style="max-width: 100%;" :style="styleVal"></img>
	</div>
</template>

<script>
export default {
  data() {
    return {
      imgUrl: '',
      styleVal: '',
    }
  },
  methods: {
    preview(val, style){
      this.styleVal = style;
      this.$axios({
        url: 'common/preview/imageOrPdfPortal',
        method: 'GET',
        params: { fjlj: val },
        responseType: 'blob'
      }).then(res => {
        if(res.status == '200'){
          const contentType = res.headers['content-type']
          const blob = new Blob([res.data], { type: contentType })
          const imageUrl = URL.createObjectURL(blob);
          this.imgUrl = imageUrl;
        }
      }).catch(error => {
        console.error("预览失败:", error);
      })
    }
  },
  beforeDestroy() {
    // 销毁释放blob资源
    if(this.imgUrl) URL.revokeObjectURL(this.imgUrl)
  }
}
</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/preview/image.vue